import React from 'react';
import { DataGrid, GridColDef } from '@fashionnovateam/nova-ui-toolkit';
import cn from 'classnames';
import { PurchaseOrderRevisionRequestedActivityDetail } from '../../../../Lib/Types/purchase-order-revision';

function formatNumber(number: number) {
  return Math.trunc(number * 100) / 100;
}

const columns: GridColDef[] = [
  {
    field: 'size',
    headerName: 'Size',
    render: 'custom',
    flex: 1,
    sortable: false,
    minWidth: 61,
    disableColumnMenu: true,
  },
  {
    field: 'new_quantity',
    headerName: 'New Qty',
    render: 'custom',
    flex: 1,
    sortable: false,
    minWidth: 141,
    disableColumnMenu: true,
  },
  {
    field: 'current_quantity',
    headerName: 'Current Qty',
    render: 'custom',
    display: 'flex',
    flex: 1,
    sortable: true,
    minWidth: 97,
    disableColumnMenu: true,
  },
  {
    field: 'quantity_difference',
    headerName: 'Qty Diff',
    render: 'custom',
    sortable: true,
    flex: 2,
    minWidth: 97,
    disableColumnMenu: true,
  },
  {
    field: 'quantity_difference_percentage',
    headerName: 'Qty Diff %',
    render: 'custom',
    sortable: false,
    flex: 1,
    minWidth: 97,
    disableColumnMenu: true,
  },
];

export function QuantityRow({
  size,
}: {
  size: NonNullable<
    NonNullable<
      PurchaseOrderRevisionRequestedActivityDetail['items']
    >[number]['sizes']
  >[number];
}) {
  const id = React.useId();
  const textDisabled = 'text-xsm text-base-disabled';
  const newQuantity = size.new_quantity;
  const currentQuantity = size.old_quantity || 0;
  const quantityDifference =
    newQuantity !== undefined
      ? formatNumber(newQuantity - currentQuantity)
      : Infinity;
  const quantityDifferencePercentage =
    newQuantity !== undefined
      ? formatNumber(((newQuantity - currentQuantity) / currentQuantity) * 100)
      : Infinity;
  const row = {
    id,
    size: (
      <span className="text-xsm text-base-primary">{size.size || 'N/A'}</span>
    ),
    new_quantity: (
      <span className="text-xsm font-semibold text-warning-700">
        {newQuantity ?? '-'}
      </span>
    ),
    current_quantity: (
      <span
        className={
          newQuantity !== undefined && newQuantity !== currentQuantity
            ? cn(textDisabled, 'line-through decoration-base-disabled')
            : ''
        }
      >
        {currentQuantity}
      </span>
    ),
    quantity_difference: (
      <span className={textDisabled}>
        {quantityDifference !== Infinity ? quantityDifference : '-'}
      </span>
    ),
    quantity_difference_percentage: (
      <span className={textDisabled}>
        {quantityDifferencePercentage !== Infinity
          ? `${quantityDifferencePercentage}%`
          : '-'}
      </span>
    ),
  };
  return row;
}

type QuantityChangeProps = {
  sizes: NonNullable<
    NonNullable<
      PurchaseOrderRevisionRequestedActivityDetail['items']
    >[number]['sizes']
  >;
};

export function QuantityChange({ sizes }: QuantityChangeProps) {
  const transformedRows = sizes.map((size) =>
    QuantityRow({
      size,
    }),
  );

  return (
    <div className="flex flex-col gap-3">
      <span className="text-xsm font-medium text-base-primary">
        Quantity Change
      </span>
      <DataGrid
        hideFilterButton
        hideGroupButton
        hideFooterPagination
        hideFooter
        hideSortButton
        rowHeight={56}
        rows={transformedRows}
        columns={columns}
      />
    </div>
  );
}
